import itTalkBySber from '../it_talk_by_sber.jpg'
import frontendMix2025 from '../frontend-mix_2025.jpg'
import uwdc2025 from '../uwdc2025.jpg'

const images = {
	itTalkBySber,
	frontendMix2025,
	uwdc2025,
}

export { images }

